<h1 mat-dialog-title>Export API</h1>

<div mat-dialog-content class="agent-dialog-content">
  <p class="intro">Create a ready-to-run export command with an administrator token that remains valid for 90 days.</p>

  <form class="agent-form" [formGroup]="formGroup">
    <mat-form-field appearance="fill" class="field">
      <mat-label>Data</mat-label>
      <mat-select formControlName="exportType">
        <mat-option value="MESSAGES">Messages</mat-option>
        <mat-option value="RAW_EVENTS">Raw events</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" class="field">
      <mat-label>Clients</mat-label>
      <mat-select formControlName="clients" multiple>
        <mat-select-trigger>{{ selectedClientLabel }}</mat-select-trigger>
        <mat-option *ngFor="let client of clients" [value]="client">{{ client.name }}</mat-option>
      </mat-select>
      <mat-error>Select at least one client</mat-error>
    </mat-form-field>

    <div formGroupName="dateRange">
      <mat-form-field appearance="fill" class="field">
        <mat-label>Date range</mat-label>
        <mat-date-range-input [rangePicker]="picker" [min]="earliestAllowedDate">
          <input matStartDate formControlName="start" placeholder="Start date">
          <input matEndDate formControlName="end" placeholder="End date">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
        <mat-error *ngIf="dateRangeGroup.get('start')?.hasError('required')">Start date is required</mat-error>
        <mat-error *ngIf="dateRangeGroup.get('end')?.hasError('required')">End date is required</mat-error>
        <mat-error *ngIf="dateRangeGroup.hasError('invalidRange')">End date must be on or after start date</mat-error>
        <mat-error *ngIf="dateRangeGroup.hasError('beforeEarliest')">Data starts Sep 1, 2025</mat-error>
      </mat-form-field>
    </div>
  </form>

  <section class="command-section" *ngIf="curlCommand">
    <div class="security-note">
      <mat-icon aria-hidden="true">warning_amber</mat-icon>
      <span>This command contains a 90-day administrator token. Treat it like a password.</span>
    </div>

    <div class="command-heading">
      <div>
        <h2>Curl command</h2>
        <p>Paste this into a terminal to download the selected data.</p>
      </div>
      <button mat-stroked-button type="button" (click)="copyCurl()">
        <mat-icon>content_copy</mat-icon>
        Copy
      </button>
    </div>

    <pre class="curl-command" tabindex="0">{{ curlCommand }}</pre>
  </section>
</div>

<div mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">Close</button>
  <button mat-flat-button color="primary" type="button" (click)="generateCurl()" [disabled]="formGroup.invalid || generating">
    {{ generating ? 'Generating…' : 'Generate curl' }}
  </button>
</div>
